import { deepEqual } from "@makeswift/controls";
var deepEqual_default = deepEqual;
export {
  deepEqual_default as default
};
//# sourceMappingURL=deepEqual.js.map